export default function ContractCPE({ isChecked, handleCheckboxChange, handleNextButtonClick }) {
    const contractText = `捷進顧問有限公司（Becker Taiwan）
「Becker CPA 考後取照與 CPE 方案」
購買契約暨同意事項說明書


一、契約審閱期間與當事人資料
甲方得於購買前審閱本契約全部條款內容至少五日。甲方於 Becker Taiwan 指定購買頁面勾選「我已閱讀並同意本契約暨同意事項」並完成付款程序前，應確認已完整審閱本契約、方案規格、購買須知、隱私權政策及相關服務規定。
立契約書人
甲方：購買者／學員

乙方：捷進顧問有限公司（Becker Taiwan）
負責人：陸秀麗
客服電子郵件：service@beckertw.com
營業所地址：臺北市大安區信義路四段 6 號 16 樓之 12
統一編號：8052-3352
甲乙雙方就甲方購買乙方提供之「執業會計師方案」相關權利義務，訂定本契約。

二、本方案名稱、適用對象與服務性質
本方案名稱為「Becker CPA 考後取照與 CPE 方案」（以下簡稱「本方案」）。
本方案適用對象為已通過美國 CPA（Certified Public Accountant）考試，並欲申請美國 CPA Active License、取得執業權利之購買者。
本方案包含諮詢、媒合與線上進修課程使用授權等服務。乙方提供之諮詢與說明，係依官方公開資訊、官方指定認證單位、官方考試單位、各州發照單位資訊及乙方過往實務經驗進行一般性說明與經驗分享，不構成法律、移民、稅務、會計師執照核發保證，亦不構成任何官方審查結果之承諾。
本方案不包含代辦服務。所有申請文件之準備、提交、追蹤、補件、繳費、官方往來及最終申請結果，均由甲方自行負責。

三、本方案內容
甲方購買本方案後，於本契約約定之有效期間內，得依本契約規定取得下列服務：
通過美國 CPA 考試後之申請執照／轉州／抵免台灣會計師考試諮詢，共三次。
美國 CPA 執照申請所需之會計師背書（work experience verification）協助服務，一次。
Becker CPE Select 一年方案使用授權。
本方案之實際服務項目、使用方式、開通程序、可使用期間及限制，除本契約另有明確約定外，均以本契約、購買頁面、購買確認信、乙方另行公告之服務規定及原廠服務條款為準。前開文件如有不一致者，應依有利於甲方之解釋或適用；但原廠服務平台之帳號、技術、使用規範及內容提供方式，仍應依原廠實際規定辦理。

四、購買前必要條件、表單資料與甲方聲明
甲方購買本方案時，應於購買表單完成下列事項：
上傳甲方本人之個人工作 CV。
上傳甲方本人已通過美國 CPA 考試之證明文件。
勾選同意並保證甲方本人已持有至少一年之會計產業工作經驗。
勾選同意並保證甲方提供之全部資料、文件、聲明及上傳內容均為真實、正確、完整、有效且未經偽造、變造或冒用。
前項所稱「至少一年之會計產業工作經驗」，包括但不限於下列範圍：
會計師事務所工作經驗。
稅務事務所工作經驗。
業界財務會計相關工作經驗。
學界會計教學或研究人員經驗。
政府單位會計人員經驗。
甲方瞭解並同意，若甲方未具備至少一年適用之會計產業工作經驗，或所提供之 CV、考試通過證明、工作經驗資料或其他文件有不實、不完整、無效、無法證明、偽造、變造或冒用情形，致使後續無法取得背書、無法提出執照申請、申請遭駁回、遭官方要求補件或發生其他不利益者，相關責任及風險均由甲方自行承擔。乙方及背書人不因此負退費、補償、賠償或保證申請成功之責任。

五、契約成立、生效與方案有效期間
甲方經由網際網路購買本方案者，於乙方指定頁面勾選「我已閱讀並同意本契約暨同意事項」並再次確認購買內容後，本契約成立。
本契約自甲方完成付款，且乙方確認款項入帳後生效。
本方案有效期間為一年，自甲方完成清款並收到乙方寄發之「購買確認信」當日起算。
本方案內所有服務，包括諮詢、會計師背書協助服務及 Becker CPE Select 一年方案，均應於本方案有效期間內預約、開通、領取或使用。甲方未於有效期間內使用之服務，於有效期間屆滿時自然失效，甲方不得要求延長、轉讓、保留至其他方案、折抵現金、退費或其他補償。
若任一服務另有原廠或平台規定之開通期限、帳號效期或使用期限，甲方亦應遵守該等規定；如該等規定與本方案一年有效期間不同，應以較早屆滿者為甲方可使用該項服務之最後期限，除非乙方另以書面或電子郵件明確通知較有利於甲方之安排。

六、申請執照／轉州／抵免台灣會計師考試諮詢服務
（一）諮詢次數與使用原則
本方案提供諮詢共三次。
甲方得依本人申請執照、轉州或抵免台灣會計師考試之需求，於本方案有效期間內向乙方預約諮詢。
甲方不必強制使用完三次諮詢；未使用完畢之諮詢次數，於本方案有效期間屆滿時自動失效，不得要求折現、退費、展延、轉讓或補償。
諮詢服務僅限甲方本人使用，不得轉讓予他人、為他人代為詢問、將諮詢機會交由第三人使用，或以他人案件作為主要諮詢內容。
（二）諮詢時間安排
如甲方諮詢州別為關島、華盛頓或蒙大拿，乙方提供：
「執照申請，流程說明」影片，可觀看一次；
「抵免台灣會計師考試，流程說明」影片，可觀看一次；
三次一對一線上諮詢，每次二十分鐘。
如甲方諮詢州別為關島、華盛頓、蒙大拿以外之其他州別，乙方提供三次一對一線上諮詢，每次五十分鐘。
單次諮詢時間屆滿時，該次諮詢即結束。若甲方問題未能於該次諮詢內全部討論完畢，甲方得於剩餘諮詢次數及方案有效期間內另行預約後續諮詢。
（三）諮詢方式與技術要求
流程說明影片於 Becker Taiwan 中文雲端教室網站或乙方指定平台觀看。
一對一線上諮詢原則上使用乙方提供之 Google Meet 連結進行。
為達最佳諮詢效率，甲方應使用個人電腦進行諮詢，並自行確認網路連線、攝影機、麥克風、瀏覽器、文件檢視及表單填寫環境可正常運作。
甲方應於諮詢前準備與申請執照、轉州、抵免台灣會計師考試相關之文件、問題清單及乙方事前要求之資料。
若因甲方設備、網路、環境、未準備文件、遲到、未出席、無法登入 Google Meet 或其他不可歸責於乙方之事由，導致諮詢無法完整進行，該次諮詢是否計入已使用次數，得依乙方事前公告或雙方約定處理；若無特別約定，乙方得將已開始進行之諮詢視為已使用。
（四）身分確認
為保護雙方權益，諮詢開始時，甲方應開啟視訊，並依乙方要求出示護照、身分證或其他可識別本人之文件，以確認諮詢者為甲方本人。甲方拒絕或無法完成身分確認者，乙方得暫停或拒絕提供該次諮詢；因此造成之延誤或無法於方案有效期間內使用服務，由甲方自行承擔。
（五）諮詢內容範圍
乙方於每次諮詢中，將依甲方個人需求、指定州別、申請進度及現有官方資訊，彈性提供下列範圍內之說明：
講解甲方指定州別之執照申請條件，包括但不限於學分、學位、工作經驗、背書人資格、應考年限、SSN 要求及其他官方規定。
逐項檢查甲方是否符合該州申請條件。
說明申請執照需準備之文件資料。
說明申請執照之執行方式，包括各州申請網站註冊、付費方式、各州聯繫窗口狀態及特殊注意事項。
視各州情況，提供無償轉介紹工作經驗背書 CPA 服務；轉介媒合對象原則上為持有美國 CPA 執照之 Becker 考生學長姊或乙方可接洽之合適背書人。
視各州情況，提供申請執照或申請台灣會計師考試抵免所需之推薦信範本、法規中譯本或相關參考資料；若無現成中譯本，乙方得告知需翻譯段落，供甲方自行委外翻譯，並得提供翻譯資源建議。
講解轉州（transfer）執行流程、可能成本及應注意事項。
（六）諮詢服務限制與免責事項
乙方顧問將針對甲方於諮詢前或諮詢預約時事先指定之州別進行準備與說明。若甲方於諮詢過程中臨時變更申請方向、州別或問題範圍，乙方可能無法即時確認最新官方規定；因此產生之判斷風險、時間延誤或申請結果，由甲方自行承擔。
乙方提供之諮詢資訊來源包括官方指定認證單位、官方考試單位、各州官方發照單位公開資訊及乙方第一手處理經驗。實際申請結果仍以各官方單位、各州會計師委員會（State Board of Accountancy）及相關主管機關之審核為準。
乙方諮詢服務為說明、提醒與經驗分享，不代替甲方作成最終判斷，不代替甲方填寫或提交申請文件，不代表官方機構發言，不構成執照核發、轉州成功或台灣會計師考試抵免成功之保證。
甲方自行負責確認官方最新規定、文件完整性、付款、送件、補件、官方溝通與申請時程。乙方不因提供諮詢而承擔代辦人、代理人、保證人或官方審查機構之責任。

七、會計師背書（work experience verification）協助服務
（一）服務次數與服務完成定義
本方案提供會計師背書協助服務一次。
本項服務係指乙方協助甲方媒合或轉介一位持有美國 CPA 執照之背書人，並協助雙方交換聯絡方式，使甲方得依背書人要求進行適當背書準備流程。
本項服務之完成，以甲方經乙方轉介認識一位持有美國 CPA 執照之背書人，並依背書人要求進行合理必要之背書準備流程後，取得背書人在執照申請表上工作經驗背書欄位簽字為原則。
若甲方未依背書人要求提供文件、未能證明適用工作經驗、無法完成背書人合理要求之確認程序、未於方案有效期間內配合聯繫或安排，或因甲方個人條件不符導致背書程序無法完成，相關結果由甲方自行負責。
（二）甲方工作經驗與文件真實性義務
甲方購買本方案時，已聲明並保證本人具備至少一年適用之會計產業工作經驗。
甲方應提供真實、正確、完整且可供合理查核之 CV、工作經驗說明、職稱、任職期間、工作內容、主管或雇主資訊及美國 CPA 考試通過證明。
若背書人或乙方於服務過程中發現甲方工作經驗明顯不足、不屬於適用範圍、資料無法證明、內容不一致、疑似不實、偽造、變造或有其他不適合背書之情形，背書人得拒絕背書或要求補充資料。甲方不得因此向乙方請求退費、補償、賠償或要求另行保證取得背書。
（三）乙方與背書人之角色分工
乙方之責任為協助甲方媒合適當背書人並交換聯絡方式。
完成媒合後，背書相關對話、文件確認、工作內容確認、執照狀態確認、身分確認、背書意願與是否簽署，均由甲方與背書人直接討論及負責。
背書人得依其專業判斷、執照州別規定、倫理規範及個人風險控管要求，請甲方提供工作經驗證明、履歷、主管聯繫方式、工作內容說明、面談、聲明書或其他資料。甲方應自行決定是否提供並承擔資料提供之相關責任。
乙方不介入背書人之專業判斷，不要求背書人為不實背書，不保證背書人必然同意簽署，也不保證背書內容必然符合任何州別之最終審查要求。
（四）官方審核與結果不保證
實際審核甲方申請文件並決定是否核發執照之權責機關，為美國各州會計師委員會（State Board of Accountancy）及其他相關官方單位。
乙方及背書人均非最終審核及發照機構。
乙方及背書人不對甲方執照申請結果作任何明示或默示保證，包括但不限於：取得背書、通過官方審查、執照核發、Active License 取得、轉州成功、抵免台灣會計師考試成功或申請時程長短。

八、Becker CPE Select 一年方案
（一）方案內容與適用提醒
本方案包含 Becker CPE Select 一年方案使用授權。
Becker CPE Select 一年方案提供甲方於使用效期內不限次數使用 Becker CPE 之直播課程（Webcast）與隨選課程（On Demand），使甲方得依個人工作與生活節奏安排進修時間。
Becker CPE Select 課程內容涵蓋會計、審計、稅務、管理顧問等 NASBA 核心專業領域，並提供多數州別，包括哥倫比亞特區、波多黎各與關島，可能要求之該州必修會計道德課程，以及多數州指定之 AICPA Code of Conduct 與 AICPA Code of Conduct (Expanded Version) 課程。
Becker CPE Select 另可能包含精選進階課程，例如稅務法規更新、會計準則變動或特定立法議題等。實際可使用之課程、課程名稱、課程時數、課程類別及課程是否持續提供，應以 Becker 原廠平台及課程 Catalog 當時顯示內容為準。
Becker CPE 全系列課程每年會依法律、產業動態及專業新知頻繁更新。各州 CPE 規定不同，甲方購買前及選課前，應自行確認本人所屬州別或主管機關是否有指定必修 CPE 課程，例如道德倫理課程，並應按照州別檢查 Becker CPE Catalog，確認所選課程是否適用。
CPE Select 課程原則上包含講師影音教學，甲方完成課程後，得依平台規定下載 CPE 完課證書。實際完課證明之產生、下載、保存及申報方式，均依 Becker 原廠平台規範辦理。
（二）使用效期、啟用與帳號規範
Becker CPE Select 一年方案之使用效期為十二個月。以清款購買當日起算十二個月後終止；惟本方案整體有效期間仍依本契約第五條，自甲方清款後收到購買確認信當日起算一年。若 CPE Select 原廠帳號效期與本方案整體效期之起算日或屆滿日不同，甲方應依較早屆滿者使用，以免權益受影響。
甲方領取或啟用帳號後，應妥善保管帳號、密碼、序號及登入資訊，並確保不為他人得知。使用甲方帳號密碼登入學習帳號者，推定為甲方本人行為。
因不可歸責於乙方之事由導致帳號或密碼外洩時，甲方應儘速通知乙方。乙方除提供必要協助外，不負任何法律責任。
為提升服務品質及確保甲方正確使用教材與平台，Becker Professional Education 與 Becker Taiwan 得於必要範圍內蒐集、處理並分析產品使用帳號之軟體登錄時間、網路位址（IP address）及相關使用資訊。
若系統發現多人登入同一帳號、異常登入、帳號分享、帳號轉售、帳號出借或其他違反個人使用授權之情形，乙方或 Becker 原廠有權暫停、中止或終止該帳號之軟體權限，甲方不得要求退費、補償或延長效期。但甲方能證明該異常使用不可歸責於本人者，乙方應於合理範圍內協助釐清。
（三）CPE 認列與甲方自行確認義務
甲方瞭解，不同州別、不同執照狀態、不同主管機關或不同專業組織對 CPE 課程類別、時數、倫理課程、申報期限、申報方式及可認列條件可能有不同規範。
甲方應自行確認本人欲申請或維持之執照州別及主管機關對 CPE 之最新要求，包含但不限於：是否要求州別指定之倫理課程、是否接受 Becker CPE 課程、課程主題與時數是否符合規定、申報方式與期限是否符合要求。
乙方提供 CPE Select 使用授權，不代表保證任何課程必然符合甲方特定州別、特定執照、特定年度或特定主管機關之 CPE 認列要求。
甲方應自行負責選課、完課、下載或保存完課證明、申報 CPE 時數及回應主管機關查核。若因甲方未完成課程、未保存證明、選課不符、逾期申報、主管機關規定變更或其他不可歸責於乙方之原因，導致 CPE 時數不被認列、執照申請或維持受影響，乙方不負保證或賠償責任。
（四）個人使用、禁止轉讓與違約責任
Becker CPE 系列方案為美國原版教材軟體，方案內含之教材、課程、服務及帳號均限甲方本人使用。
甲方應遵循 Becker 原廠服務政策及乙方使用規範，嚴禁任何形式之轉售、轉贈、轉讓、出租、出借、分享、共同使用或提供第三人使用。
CPE Select 課程內容、講義、測驗、完課證明及平台資料均受智慧財產權保護。甲方不得錄音、錄影、翻拍、截錄、下載非平台允許下載之內容、重製、散布、公開傳輸、改作、販售或作其他逾越授權範圍之使用。
甲方違反本條規定者，乙方或 Becker 原廠得暫停、中止或終止甲方帳號及服務權限。若因此造成乙方、Becker 原廠或第三人損害，甲方應負損害賠償責任。就轉售、轉贈、轉讓、分享或多人共用等重大違約行為，乙方得請求甲方賠償購買總價十倍之懲罰性違約金及其他實際損害；惟如法院或主管機關認定違約金過高，得依法酌減。
（五）原廠停產、規格異動與服務調整
甲方瞭解 Becker CPE Select 為 Becker Professional Education 原廠提供之產品。若因原廠停產、停止供貨、服務調整、平台改版、課程下架、課程規格變更、授權政策變更或其他不可歸責於乙方之因素，導致產品內容、課程清單、平台功能或服務方式調整，乙方得依原廠實際供應情形調整提供方式。
前項調整如重大影響甲方已購買服務之主要內容，乙方應於知悉後儘速通知甲方，並於合理範圍內提供替代方案、協助處理。

九、帳號、密碼、電子郵件與通知
甲方使用本方案相關服務所需之帳號、序號、密碼、購買確認信、開通通知、預約通知、補件要求、方案變更通知及其他重要資訊，乙方得以電子郵件、購買頁面、會員系統、LINE 官方帳號或乙方指定方式通知甲方。
甲方應提供可正常收信且有效期限足以涵蓋本方案有效期間之 E-mail，並自行定期收信、檢查垃圾郵件匣及維持聯絡資料正確。
因甲方未更新聯絡資料、未收信、信箱容量不足、郵件遭擋信、未查看通知或其他不可歸責於乙方之事由，導致權益受影響者，由甲方自行負責。
甲方應妥善保管其帳號、密碼、序號及登入資訊。以甲方帳號密碼登入或使用服務者，推定為甲方本人行為；但如甲方能證明係不可歸責於甲方之第三人非法使用，雙方應依本契約及相關法令處理。

十、設備規格與使用環境
甲方使用本方案之線上服務、影片、Google Meet 諮詢、CPE Select 或其他網際網路服務時，應自行備妥符合服務平台要求之設備、作業系統、瀏覽器、網路連線、攝影機、麥克風及文件檢視工具。
建議基本規格如下；如乙方或原廠另有較新規定，從其規定：
Windows：Windows 7 以上。
MacOS：10 以上。
iOS：13 以上，限 App 使用情境。
Android：8 以上，限 App 使用情境。
寬頻網路下載速度建議 20 Mbps 以上。
行動裝置觀看課程時，應依平台規範使用 App 版。
不建議使用公共免費網路、社區型網路、無線網路、有線電視台網路或其他可能造成驗證登入異常、連線不穩定或個人帳號密碼外洩之網路環境。
其餘未列示之軟硬體、作業系統、瀏覽器、裝置或系統環境，乙方及原廠不保證其觀看品質、登入穩定性或完整功能支援。甲方連結乙方或原廠指定網站系統之接取網路，除經雙方另有明確約定由乙方提供者外，應由甲方自行向合法電信或網路服務業者申請租用，相關權利義務依甲方與該業者間契約處理。

十一、個人使用、禁止轉讓與智慧財產權
本方案所有服務、帳號、課程、諮詢、背書媒合服務、文件範本、影片、講義、法規中譯本、CPE Select 使用授權及其他資料，均限甲方本人依本契約目的使用。
未經乙方事前書面同意，甲方不得將本方案之全部或一部權利轉讓、轉售、贈與、出租、出借、分享、提供予第三人使用，亦不得以任何方式使第三人取得本方案利益。
甲方不得對乙方或原廠提供之課程、影片、諮詢內容、講義、範本、翻譯資料、網站畫面或其他內容進行錄音、錄影、截圖、翻拍、重製、散布、公開傳輸、改作、販售或其他侵害智慧財產權之行為。但平台明確允許下載或保存之資料，不在此限，惟仍限甲方本人合理使用。
甲方違反本條約定者，應自負一切法律責任；乙方得依違約情節暫停或終止提供服務，並依法請求損害賠償。

十二、服務品質、系統異常與第三方平台
乙方應提供具有合理期待安全性之服務，並就可歸責於乙方之系統錯誤、畫面暫停、遲滯、中斷、不能連線或其他服務品質瑕疵，依本契約及相關法令處理。
乙方因可歸責於自己之事由，致甲方無法使用本方案服務者，乙方應儘速更正或修復，並依服務性質，以延長使用期間、補回諮詢次數、另行安排諮詢、補發資料或其他合理方式補償甲方。
若服務品質瑕疵係因 Google Meet、Becker 原廠平台、CPE Select 平台、網路服務業者、甲方設備、甲方網路、不可抗力或其他不可歸責於乙方之第三方因素所致，乙方將於合理範圍內協助甲方排除或向第三方反映，但不保證第三方平台之持續可用性、內容不變或系統不發生異常。
乙方對於本服務相關軟硬體設備進行必要搬遷、更換、升級、保養或維修時，得暫停本服務之全部或一部。

十三、個人資料蒐集、處理及利用
甲方同意乙方為提供本方案服務、確認購買資格、進行帳號開通、安排諮詢、媒合背書人、聯繫通知、客服處理、申訴處理、內部紀錄、行銷、調查、統計、研究分析及依法保存契約資料之目的，於必要範圍內蒐集、處理及利用甲方個人資料。
依個人資料保護法第八條第一項，乙方向甲方告知下列事項：
蒐集目的：包括但不限於 040 行銷、069 契約、類似契約或其他法律關係事務、090 消費者客戶管理與服務、157 調查、統計與研究分析、181 其他經營合於營業登記項目或組織章程所定之業務、182 其他諮詢與顧問服務，以及本方案履行所必要之相關目的。
個人資料類別：包括但不限於 C001 電子郵件、中文姓名、英文拼音全名、電話號碼；C002 金融機構帳戶號碼與姓名；C003 身分證字號或護照號碼；C036 是否曾訂購本公司產品、得知本公司之管道；C038 在職身分；C051 所屬或畢業學校與科系；以及甲方提供之 CV、工作經驗、考試通過證明、申請州別、諮詢紀錄、學習紀錄、購買紀錄及其他為履行本方案所必要之資料。
個人資料利用期間與地區：於甲方使用乙方服務期間、契約保存期間、依法令或業務執行所必要期間，於乙方營業所在地、服務提供地、原廠平台所在地及完成本方案所必要之地區利用。
個人資料利用對象及方法：乙方將依甲方填寫之訂購資料確認訂購、註冊帳號、開通商品、提供學員管理、客服、行銷活動、申訴處理、統計分析及本方案相關服務。乙方亦得於必要範圍內將資料提供予 Becker Professional Education、支付或金流服務提供者、系統服務提供者、背書人或其他為履行本方案所必要之合作對象。
在未經甲方同意或非依法令、契約履行必要範圍之情形下，乙方不會將甲方個人資料提供予第三人或作不當利用。
甲方瞭解並同意，為執行會計師背書協助服務，乙方可能需將甲方姓名、聯絡方式、CV、考試通過證明、工作經驗摘要或其他甲方同意提供之必要資料提供予潛在背書人，以利背書人評估是否進行背書程序。乙方及背書人均應於本方案目的必要範圍內使用該等資料。
甲方得依個人資料保護法第三條規定，就其個人資料向乙方請求查詢、閱覽、製給複製本、補充、更正、停止蒐集處理利用或刪除；如欲行使權利，得來信 service@beckertw.com。
若甲方拒絕提供或未能提供正確完整之必要資料，乙方可能無法確認購買資格、開通服務、安排諮詢、完成 CPE 帳號註冊或進行背書媒合，相關不利益由甲方自行承擔。

十四、授權使用費與付款方式
本方案授權使用費為新臺幣兩萬八千元整（含營業稅），或以甲方購買時乙方購買頁面、報價單、發票或購買確認信所載優惠總價為準。
付款方式為一次全部繳納，除乙方另行書面同意外，甲方應於購買當日或乙方指定期限內完成付款。
乙方確認款項入帳後，始寄發購買確認信並啟動本方案後續服務流程。
如乙方另提供優惠、折扣、加價購、贈品或其他促銷方案，該等內容應以購買當時乙方明示之條件為準，並應作為本契約之一部分。

十五、契約終止、服務期間與期滿效果
甲方得依相關法令及本契約約定通知乙方終止本契約。乙方不得以本契約條款排除或限制甲方依法享有之解除權、終止權或退費權。
本方案包含網際網路教學服務、數位內容、線上服務及原廠軟體授權；就非以有形媒介提供之數位內容或一經提供即為完成之線上服務部分，並經甲方事前知悉及同意後提供者，依通訊交易解除權合理例外相關規定，得排除消費者保護法第十九條第一項七日解除權之適用。惟甲方於購買後七日內，且尚未領取教材或帳號、尚未啟用或登入任何產品內含學習帳號、尚未開始觀看課程、尚未預約或使用諮詢、尚未開始背書媒合程序者，得向乙方提出契約解除申請。
甲方一經領取教材、領取或啟用帳號、登入任何產品內含學習帳號、開始觀看課程、開始使用 CPE Select、預約或完成任一諮詢、開始背書媒合程序，或使用本方案任一主要服務後，即屬服務已開始提供或授權成本已發生。除依法令或可歸責於乙方之事由外，甲方不得要求全額返還價金或暫停效期。
甲方於本方案有效期間內依法或依本契約約定提前終止契約者，雙方應依本方案各服務項目之性質、服務進度、開通狀態、已使用次數、已使用期間、已安排或已執行事項、第三方或原廠已發生且不可返還之成本，以及雙方可歸責事由，辦理契約終止結算。
本方案為固定期間制之整合型服務方案，方案價金係對應甲方於有效期間內取得本方案整體服務使用資格，而非以甲方實際使用完畢各項服務為必要。服務提供狀態之認定，包含但不限於下列事項：
諮詢服務：已預約並完成、已開始進行，或因甲方可歸責事由未能完成者，均得認定為該次服務已提供。
會計師背書協助服務：乙方已進行背書人搜尋、媒合、轉介、交換聯絡方式、提供必要溝通或協助進入背書準備程序者，得依其進度認定服務已提供。
Becker CPE Select：帳號或使用授權已申請、開通、寄發、可登入、可兌換、已登入，或依原廠規定已產生授權成本者，得認定服務已提供。
期間使用資格：自購買確認信寄發日起至契約終止日止，本方案處於可預約、可安排、可開通或可使用狀態之期間，亦屬本方案服務提供之一部分。
本方案有效期間屆滿時，甲方尚未預約、尚未開通、尚未領取、尚未使用或尚未使用完畢之服務資格，均隨期間屆滿而自然失效。期滿後，乙方不負保留、展延、折抵、移轉、替換、轉換現金或辦理期滿後價金結算之義務。但因可歸責於乙方之事由致甲方無法於有效期間內使用服務，或法令另有強制規定者，不在此限。
如契約提前終止係因可歸責於甲方之事由所致，乙方得於依法可扣除範圍內，就已提供服務、已發生成本、第三方或原廠不可返還費用及合理違約金辦理結算；但不得逾相關法令所允許之範圍。
退費方式原則上以匯款方式辦理，乙方得請甲方提供本人帳戶資料。退費期限依雙方約定及相關法令辦理。
甲方如有違反強制或禁止規定、公序良俗、智慧財產權、帳號使用規範、禁止轉讓分享規範，或違反本契約經乙方定合理期間通知改正仍未改正者，乙方得終止本契約。若甲方自行或因可歸責於己之事由終止契約，且教材一經領取、帳號一經登入或服務已開始使用者，除依法令另有規定外，不得要求退費。

十六、不可抗力
因天災、戰爭、暴動、疫情、政府命令、法令變更、罷工、網路重大故障、第三方平台重大異常、原廠停止服務、官方政策變更或其他不可抗力事件，致本契約全部或一部無法履行者，雙方得協議展延、替代履行、部分終止或全部終止。契約終止時，乙方應依已提供服務比例及相關法令辦理結算。

十七、申訴、客服與補習服務聯合連帶保證
甲方對於乙方所提供之本方案服務，如有疑問、異議或申訴，得以電子郵件 service@beckertw.com 或乙方公告之其他方式聯繫乙方。乙方應自接獲甲方申訴之日起十五日內妥適處理或回覆處理進度。

十八、契約附件與效力
本契約、購買頁面、方案規格表、購買確認信、購買須知、乙方公告之服務規範、CPE Select 原廠服務條款及乙方廣告，均為本契約之一部分。
前項文件如有與本契約條款牴觸者，應為有利於甲方之適用。但第三方或原廠平台之技術規格、帳號規範、內容更新、平台操作方式及其可提供服務範圍，仍以該第三方或原廠實際規定為準。
本契約成立時，乙方應將本契約及相關附件提供甲方下載儲存，或依甲方請求以電子文件方式提供。
本契約保存期間為五年。

十九、契約解釋、準據法與管轄法院
本契約條款如有疑義，應依中華民國法律及消費者保護相關法令解釋；如有疑義且涉及定型化契約條款，應為有利於甲方之解釋。
因本契約所生之一切爭議，雙方同意以臺灣臺北地方法院為第一審管轄法院。但不得排除消費者保護法第四十七條、民事訴訟法第四百三十六條之九或其他法律所定消費者得主張之管轄法院適用。`;

    const renderLine = (line, index) => {
        const text = line.trim();

        if (!text) {
            return <div key={index} className="mb-3"></div>;
        }

        if (index === 0 || text === "購買契約暨同意事項說明書") {
            return (
                <div key={index} className="text-center mb-2">
                    {text}
                </div>
            );
        }

        if (text === "「Becker CPA 考後取照與 CPE 方案」") {
            return (
                <div key={index} className="text-center mb-2">
                    {text}
                </div>
            );
        }

        if (/^[一二三四五六七八九十]+、/.test(text)) {
            return (
                <div key={index}>
                    <div className="br mb-5 mt-3"></div>
                    <div className="h4">{text}</div>
                </div>
            );
        }

        if (/^（[一二三四五六七八九十]+）/.test(text)) {
            return <div key={index} className="h5 mt-4">{text}</div>;
        }

        if (
            text.startsWith("甲方（購買者／學員）姓名") ||
            text.startsWith("身分證字號或護照號碼") ||
            text.startsWith("電話：") ||
            text.startsWith("E-mail：") ||
            text.startsWith("地址：") ||
            text.startsWith("簽名／蓋章") ||
            text.startsWith("簽署日期") ||
            text.startsWith("乙方：") ||
            text.startsWith("負責人：") ||
            text.startsWith("客服電子郵件：") ||
            text.startsWith("營業所地址：") ||
            text.startsWith("統一編號：") ||
            text.startsWith("日期：")
        ) {
            return <div key={index} className="mb-2">{text}</div>;
        }

        return <p key={index} className="mb-2">{text}</p>;
    };

    return (
        <div className="container mb100 mt100">
            <div className="beckertitlename mb100 mt100">Becker CPA 考後取照與 CPE 方案</div>
            <div className="card w-75 p-5 m-auto">
                <h5 className="card-title text-black text-center">購買契約暨同意事項說明書</h5>
                <div className="br mb-5 mt-3"></div>
                <div className="card-body">
                    <div className="card-text m-auto">
                        {contractText.split("\n").map(renderLine)}
                    </div>

                    <div className="text-center">
                        <label>
                            <input
                                className="m-2"
                                type="checkbox"
                                value="read"
                                checked={isChecked}
                                onChange={handleCheckboxChange}
                                required
                            />
                            <span>我已詳閱並且了解</span>
                        </label>
                        <div className="btn btn-primary m-3" onClick={handleNextButtonClick}>下一步</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
